import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useGetIt from '../../../../../hooks/useGetIt';
import { formatToNaira } from '../../../../../helpers/utils';
import { Loader } from '@piggytechng/component-library';
import './GetItTab.scss';
import chevronTable from '../../../../../assets/icons/chevronTable.svg';
import GetItRefundDetails from '../../../../../components/NewSideSheet/GetItRefundDetails';

const GetItTab = () => {
  const [activeFilter, setActiveFilter] = useState('active');
  const [showRefundDetails, setShowRefundDetails] = useState(false);
  const [selectedRefund, setSelectedRefund] = useState<any>(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const userId = id as string;
  const getStatusFromFilter = (filter: string) => {
    switch (filter) {
      case 'active':
        return 'active';
      case 'completed':
        return 'completed';
      case 'refund':
        return 'underfunded_refunded';
      case 'paused':
        return 'paused';
      default:
        return '';
    }
  };

  const { subscriptions, isLoading } = useGetIt({
    status: getStatusFromFilter(activeFilter),
    page: 1,
    limit: 20,
  });

  const filters = ['Active', 'Completed', 'Refund', 'Paused'];

  const handleRowClick = (item: any) => {
    if (activeFilter === 'refund') {
      setSelectedRefund(item);
      setShowRefundDetails(true);
    } else {
      navigate(`/view-getit/${id}/${item.reference}/${activeFilter}`);
    }
  };

  return (
    <div className="getit-tab">
      <div className="getit-filters">
        {filters.map((filter) => (
          <div
            key={filter}
            className={`filter-item ${activeFilter === filter.toLowerCase() ? 'active' : ''}`}
            onClick={() => setActiveFilter(filter.toLowerCase())}
          >
            {filter}
          </div>
        ))}
      </div>

      <div className="getit-header flex--3">
        <h2>Purchases</h2>
        {subscriptions.length > 3 && (
          <span className="view-all pointer" onClick={() => navigate(`/view-all-getit/${userId}/${activeFilter}`)}>
            View all
          </span>
        )}
      </div>

      <div className="getit-list">
        {isLoading ? (
          <div
            className="flex--2"
            style={{ height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <Loader />
          </div>
        ) : subscriptions.length > 0 ? (
          subscriptions.slice(0, 3).map((item, index) => (
            <div key={index} className="getit-item pointer" onClick={() => handleRowClick(item)}>
              <div
                className="item-thumb"
                style={{
                  backgroundImage: `url(${item.purchase.item.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              />
              <div className="item-info">
                <h3>{item.purchase.item.title}</h3>
                <p className="item-id">ID: {item.reference}</p>
                <p className="item-frequency">
                  {formatToNaira(item.amounts.per_debit_amount)} {item.payment_schedule.cadence_label}
                </p>
              </div>
              <div className="item-cost">
                <h4 className="total-cost">{formatToNaira(item.amounts.target_amount)}</h4>
                <p className="end-date">Ends: {item.duration.target_date.split(' ')[0]}</p>
              </div>
              <img src={chevronTable} alt="chevron" className="chevron-table" />
            </div>
          ))
        ) : (
          <div className="no-data">No {activeFilter} purchases found.</div>
        )}
      </div>

      <GetItRefundDetails show={showRefundDetails} onClose={() => setShowRefundDetails(false)} data={selectedRefund} />
    </div>
  );
};

export default GetItTab;
